<template>
  <div>
    <div class="position-relative overflow-hidden" v-if="pageContents">
      <div class="d-flex align-items-center rounded img-bg img-bg-2 w-100"
           :style="`background-image: url('${pageContents.image_url}')`">
        <div
          class="d-flex justify-content-between flex-grow-1 flex-column flex-lg-row align-items-start align-items-lg-center p-4"
          style="top:0; left: 0">
          <div class="text-white pr-lg-4" style="max-width: 400px">
            <h3 v-if="pageContents.search_banner_title" class="font-weight-semi-bold">
              {{ pageContents.search_banner_title }}
            </h3>
            <h6 v-if="pageContents.search_banner_subtitle">
              {{ pageContents.search_banner_subtitle }}
            </h6>
          </div>

          <div>
            <a v-if="pageContents.search_banner_button_title" :href="pageContents.search_banner_url"
               class="btn btn-primary">
              {{ pageContents.search_banner_button_title }}
            </a>
          </div>
        </div>
      </div>
      <a class="tw-absolute tw-inset-0"
         target="_blank"
         :href="pageContents.search_banner_url"
         v-if="pageContents.search_banner_url"></a>
    </div>
  </div>
</template>

<script>
import normalize from "json-api-normalize";
import Attributes from "../../models/Attributes.js";

export default {

  data() {
    return {
      pageContents: null
    }
  },

  mounted() {
    this.$http.get("/page_contents/search-banner").then(fulfilled => {
      if (fulfilled.body) {
        this.pageContents = normalize(fulfilled.body).get(Attributes.pageContentsAttributes)
      }
    })
  }
}
</script>